export default __webpack_public_path__ + "static/album-1f4491a15578c9091ec1efd9c24baf6b.png";